import { EmployeeDto, OrderDto } from '@up/data';

export type ReopenTableOrderDto = Pick<
  OrderDto,
  | 'createdDate'
  | 'id'
  | 'merchant'
  | 'orderPayments'
  | 'orderPosTableInfo'
  | 'totalPrice'
  | 'createdDate'
> & { operatorEmployee: EmployeeDto; markedForDelete?: boolean };
